import Step from './Step';


Step.install = function(Vue) {
  Vue.component(Step.name, Step);
};

export default Step;
